// Enumerations
import { DevicesBreakpointsEnumeration } from '../../../../../enumerations/devices/devices-breakpoints.enumeration';
// Foundations
import { FontsLineHeightsFoundationsThemes } from '../../commons/fonts-line-heights-foundations.themes';
import { FontsSizesFoundationsThemes } from '../../commons/fonts-sizes-foundations.themes';
const FoundationsKubitCobrandedRegularFontsParagraphsTheming = {
    font_paragraph_50: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
    },
    font_paragraph_100: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
    },
    link_font_paragraph_50: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
    },
    link_font_paragraph_100: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_large,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_large,
        },
    },
    font_paragraph_200: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
    },
    font_paragraph_250: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
    },
    link_font_paragraph_200: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
    },
    link_font_paragraph_250: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_medium,
        },
    },
    font_paragraph_350: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
    },
    font_paragraph_400: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
    },
    link_font_paragraph_350: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
    },
    link_font_paragraph_400: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_paragraph_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_paragraph_small,
        },
    },
    font_paragraph_500: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
    },
    font_paragraph_550: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
    },
    link_font_paragraph_500: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
    },
    link_font_paragraph_550: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_medium,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_medium,
        },
    },
    font_paragraph_650: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_small,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_small,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_small,
        },
    },
    font_paragraph_700: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_small,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_small,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_caption_small,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_caption_small,
        },
    },
};
export { FoundationsKubitCobrandedRegularFontsParagraphsTheming };
//# sourceMappingURL=foundations-kubit-cobranded-regular-fonts-paragraphs.theming.js.map